import React from "react";
import styled from "styled-components";

function DownloadButton({ children, href, icon, onClick }) {
  return (
    <Container>
      <a className="btn" href={href} onClick={onClick} download>
        {children} {icon}
      </a>
    </Container>
  );
}

export default DownloadButton;

const Container = styled.div`
   {
    margin-bottom: 2rem;
  }

  .btn {
    padding: 1.4rem 3.4rem;
    gap: 2rem;
    font-size: 1.1rem;
    color: var(--color-white);
    background: var(--color-primary);
    margin: 2rem 0;
    cursor: pointer;
    position: relative;
    z-index: 1;
    font-weight: bold;
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  }

  .btn:hover {
    opacity: 0.5;
  }

  @media only screen and (min-width: 320px) {
     {
      margin-top: 3rem;
    }

    .btn {
      display: block;
      padding: 1.4rem 0;
    }
  }

  @media only screen and (min-width: 768px) {
     {
      margin-top: 3rem;
    }

    .btn {
      display: block;
      padding: 1.4rem 0;
    }
  }

  @media only screen and (min-width: 1200px) {
     {
      margin-top: 3rem;
    }

    .btn {
      display: flex;
      padding: 1.4rem 3.4rem;
    }
  }
`;
